import React from 'react'
import styled, { css } from 'styled-components'

const TOGGLE_HEIGHT = 24
export const toggleFieldStyles = css`
	display: flex;
	align-items: center;

	.label {
		&.off,
		&.single {
			margin-right: 0.5em;
		}
		&.on {
			margin-left: 0.5em;
		}
	}

	.toggle-input {
		height: ${TOGGLE_HEIGHT}px;
		width: ${TOGGLE_HEIGHT * 1.75}px;
		border-radius: ${TOGGLE_HEIGHT}px;
		background: ${props => props.theme.colors.midNeutral.val};
		border: solid 2px;
		position: relative;
		display: block;
		box-sizing: content-box;

		&:hover {
			cursor: pointer;
		}

		&:before {
			content: '';
			display: block;
			height: ${TOGGLE_HEIGHT}px;
			width: ${TOGGLE_HEIGHT}px;
			background: ${props => props.theme.colors.white.val};
			border-radius: ${TOGGLE_HEIGHT}px;
			position: absolute;
			top: 0;
			left: 0;
			transition: all ${props => props.theme.times.tranS};
		}

		input {
			display: none;
		}
	}

	&.__on {
		.label.off {
			color: ${props => props.theme.colors.text.val};
		}
		.label.on {
			color: ${props => props.theme.colors.secondary.val};
		}
		.toggle-input {
			background: ${props => props.theme.colors.secondary.val};
			border-color: ${props => props.theme.colors.secondary.val};
			&:before {
				transform: translate3d(${TOGGLE_HEIGHT * 0.75}px, 0, 0);
			}
		}
	}

	&.__off {
		.label.off {
			color: ${props => props.theme.colors.secondary.val};
		}
		.label.on {
			color: ${props => props.theme.colors.text.val};
		}
		.toggle-input {
			background: ${props => props.theme.colors.midNeutral.val};
			border-color: ${props => props.theme.colors.midNeutral.val};
			&:before {
				transform: translate3d(0, 0, 0);
			}
		}
	}

	&.__inverted-toggle {
		.toggle-input {
			&:before {
				transform: translate3d(${TOGGLE_HEIGHT * 0.75}px, 0, 0);
			}
		}

		&.__on {
			.toggle-input {
				&:before {
					transform: translate3d(0px, 0, 0);
				}
			}
		}
	}

	&.__inverted-label {
		.label {
			margin-right: 0;
			margin-left: 0.5em;
		}
	}
`

const ToggleFieldView = styled.div`
	${toggleFieldStyles}
`

export type ToggleFieldProps = {
	label: string | [OffLabel: string, OnLabel: string]
	isOn: boolean
	onChange: (isOn: boolean) => void
	name?: string
	invertLabel?: boolean
	invertToggle?: boolean
	className?: string
}
export const ToggleField = ({
	label,
	isOn,
	invertLabel,
	invertToggle,
	name,
	className,
	onChange,
}: ToggleFieldProps) => {
	const isLabelArray = label instanceof Array
	const isDualLabel = isLabelArray && label.length === 2

	const leftLabel = isDualLabel && label[0]
	const rightLabel = isDualLabel && label[1]

	return (
		<ToggleFieldView
			className={`toggle-field${className ? ` ${className}` : ''}${
				isDualLabel ? ' __dual-label' : ' __single-label'
			}${isOn ? ' __on' : ' __off'}${invertToggle ? ' __inverted-toggle' : ''}${
				invertLabel ? ' __inverted-label' : ''
			}`}
		>
			{leftLabel ? <span className='label off'>{leftLabel}</span> : null}
			{!isDualLabel && !invertLabel ? <span className='label single'>{label}</span> : null}
			<label className='toggle-input'>
				<input name={name} type='checkbox' checked={isOn} onChange={() => onChange(!isOn)} />
			</label>
			{!isDualLabel && invertLabel ? <span className='label single'>{label}</span> : null}
			{rightLabel ? <span className='label on'>{rightLabel}</span> : null}
		</ToggleFieldView>
	)
}
